import { useState } from "react";
import { dialog } from "../../../nq-component";

const SK = {
  blueDark: "#002580",
  blue: "#0038A8",
  blueLight: "#1a4fc4",
  yellow: "#FCD116",
  blueShadow: "rgba(0,56,168,0.25)",
  redGradient: "linear-gradient(135deg, #c0392b 0%, #e74c3c 100%)",
  redShadow: "rgba(231,76,60,0.3)",
};

function DialogCancel({ onConfirm, onCancel }) {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) return;
    dialog.close();
    setTimeout(() => {
      dialog.fire({
        html: (
          <div
            style={{
              minWidth: "min(380px, 90vw)",
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid rgba(231,76,60,0.2)",
            }}
          >
            {/* Confirm header */}
            <div
              style={{
                background: SK.redGradient,
                borderBottom: `4px solid ${SK.yellow}`,
                padding: "1rem 1.5rem",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.18)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <i
                  className="bi bi-exclamation-triangle-fill"
                  style={{ color: "#fff", fontSize: "1.1rem" }}
                />
              </div>
              <div>
                <div
                  style={{ fontSize: "1rem", fontWeight: 800, color: "#fff" }}
                >
                  Confirm Cancellation
                </div>
                <div
                  style={{
                    fontSize: "0.75rem",
                    color: SK.yellow,
                    fontWeight: 600,
                  }}
                >
                  This action cannot be undone
                </div>
              </div>
            </div>
            {/* Body */}
            <div style={{ padding: "1.25rem 1.5rem", background: "#fff" }}>
              <p style={{ fontSize: "0.9rem", color: "#1a2a4a", margin: 0 }}>
                Are you sure you want to <strong>cancel</strong> this inquiries?
              </p>
              <div
                style={{
                  marginTop: "10px",
                  padding: "10px 12px",
                  borderRadius: "8px",
                  background: "rgba(231,76,60,0.06)",
                  border: "1px solid rgba(231,76,60,0.18)",
                  fontSize: "0.85rem",
                  color: "#495057",
                }}
              >
                <i
                  className="bi bi-chat-left-text me-2"
                  style={{ color: "#e74c3c" }}
                />
                <strong>Reason:</strong> {reason}
              </div>
            </div>
            {/* Footer */}
            <div
              style={{
                padding: "0.75rem 1.5rem",
                background: "#f9fafb",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={() => dialog.close()}
                style={{
                  padding: "8px 20px",
                  borderRadius: "8px",
                  border: "1.5px solid #cdd5e0",
                  background: "#fff",
                  color: "#495057",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                <i className="bi bi-arrow-left me-1" /> Back
              </button>
              <button
                onClick={() => {
                  onConfirm(reason);
                  dialog.close();
                }}
                style={{
                  padding: "8px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: SK.redGradient,
                  color: "#fff",
                  fontSize: "0.875rem",
                  fontWeight: 700,
                  cursor: "pointer",
                  boxShadow: `0 2px 8px ${SK.redShadow}`,
                }}
              >
                <i className="bi bi-x-circle-fill me-1" /> Confirm Cancel
              </button>
            </div>
          </div>
        ),
        footer: false,
      });
    }, 200);
  };

  return (
    <div
      style={{
        minWidth: "min(420px, 92vw)",
        borderRadius: "16px",
        overflow: "hidden",
        border: "1px solid rgba(231,76,60,0.2)",
        boxShadow: `0 8px 32px ${SK.redShadow}`,
      }}
    >
      {/* Header */}
      <div
        style={{
          background: SK.redGradient,
          borderBottom: `4px solid ${SK.yellow}`,
          padding: "1rem 1.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i
              className="bi bi-x-circle-fill"
              style={{ color: "#fff", fontSize: "1.1rem" }}
            />
          </div>
          <div>
            <div style={{ fontSize: "1rem", fontWeight: 800, color: "#fff" }}>
              Cancel Inquiries
            </div>
            <div
              style={{ fontSize: "0.75rem", color: SK.yellow, fontWeight: 600 }}
            >
              Provide a reason for cancellation
            </div>
          </div>
        </div>
        <button
          onClick={onCancel}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "none",
            borderRadius: "6px",
            color: "#fff",
            width: "30px",
            height: "30px",
            cursor: "pointer",
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <i className="bi bi-x" />
        </button>
      </div>

      {/* Body */}
      <div style={{ padding: "1.5rem", background: "#fff" }}>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "0.82rem",
            fontWeight: 700,
            color: "#1a2a4a",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            marginBottom: "8px",
          }}
        >
          <i className="bi bi-chat-left-text" style={{ color: "#e74c3c" }} />
          Reason for Cancellation
        </label>
        <textarea
          className="form-control rounded-3"
          rows={4}
          placeholder="e.g. Incomplete documents, invalid inquiries..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          style={{
            border: "1.5px solid #cdd5e0",
            padding: "10px 14px",
            fontSize: "0.9rem",
            resize: "vertical",
            color: "#1a2a4a",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#e74c3c";
            e.target.style.boxShadow = "0 0 0 3px rgba(231,76,60,0.12)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#cdd5e0";
            e.target.style.boxShadow = "none";
          }}
        />
        {reason.length === 0 && (
          <p
            style={{
              fontSize: "0.78rem",
              color: "#e74c3c",
              marginTop: "6px",
              marginBottom: 0,
            }}
          >
            <i className="bi bi-info-circle me-1" />A reason is required to
            cancel this request.
          </p>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0.75rem 1.5rem",
          background: "#f9fafb",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <button
          onClick={onCancel}
          style={{
            padding: "8px 20px",
            borderRadius: "8px",
            border: "1.5px solid #cdd5e0",
            background: "#fff",
            color: "#495057",
            fontSize: "0.875rem",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#adb5bd";
            e.currentTarget.style.color = "#1a2a4a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#cdd5e0";
            e.currentTarget.style.color = "#495057";
          }}
        >
          <i className="bi bi-x-circle me-1" /> Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={!reason.trim()}
          style={{
            padding: "8px 20px",
            borderRadius: "8px",
            border: "none",
            background: reason.trim() ? SK.redGradient : "#cdd5e0",
            color: "#fff",
            fontSize: "0.875rem",
            fontWeight: 700,
            cursor: reason.trim() ? "pointer" : "not-allowed",
            boxShadow: reason.trim() ? `0 2px 8px ${SK.redShadow}` : "none",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            if (reason.trim()) {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = `0 4px 14px ${SK.redShadow}`;
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = reason.trim()
              ? `0 2px 8px ${SK.redShadow}`
              : "none";
          }}
        >
          <i className="bi bi-x-circle-fill me-1" /> Confirm
        </button>
      </div>
    </div>
  );
}

export default DialogCancel;
